import { Reveal } from '@/components/motion/Reveal'
import { ScrambleText } from '@/components/motion/ScrambleText'
import { SplitText } from '@/components/motion/SplitText'
import { SectionIndex } from '@/components/ui/SectionIndex'
import { useTranslations } from '@/app/site-context'

export function About() {
  const { about } = useTranslations()

  return (
    <section className="about section" id="about" aria-labelledby="about-title">
      <h2 className="visually-hidden" id="about-title">
        {about.title}
      </h2>

      <SectionIndex value="04" />
      <p className="about__statement">
        <SplitText text={about.statementBefore} stagger={48} />{' '}
        <SplitText text={about.statementAccent} stagger={48} delay={240} accent />
      </p>

      <Reveal variant="rise" delay={160}>
        <p className="about__lede">{about.lede}</p>
      </Reveal>

      <div className="about__block">
        <Reveal variant="clip">
          <h3 className="about__block-title">
            <ScrambleText text={about.processTitle} />
          </h3>
        </Reveal>
        <ol className="about__steps">
          {about.steps.map((step, index) => (
            <li key={step.index}>
              <Reveal variant="slam" delay={index * 100} className="about__step">
                <span className="about__step-index" aria-hidden="true">
                  {step.index}
                </span>
                <h4 className="about__step-title">{step.title}</h4>
                <p className="about__step-body">{step.body}</p>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>

      <div className="about__block">
        <Reveal variant="clip">
          <h3 className="about__block-title">
            <ScrambleText text={about.valuesTitle} />
          </h3>
        </Reveal>
        <ul className="about__values">
          {about.values.map((value, index) => (
            <li key={value.title}>
              <Reveal variant="rise" delay={index * 100} className="about__value">
                <span className="about__value-marker" aria-hidden="true" />
                <h4 className="about__value-title">{value.title}</h4>
                <p className="about__value-body">{value.body}</p>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
